import { IonToolbar as IonicIonToolbar } from '@ionic/react'
import styled from 'styled-components'
import { isMobileApp } from '~/shared/config/constants'
import { IconButton } from '~/shared/ui/Buttons'
import { BODY_MAX_WIDTH, myPalette } from '~/shared/ui/theme'

export const CameraAltButton = styled(IconButton)`
  font-size: 60px;
  width: 110px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
`

export const ErrorMessage = styled.div`
  color: ${myPalette.white.main};
  text-align: center;
  margin: 40px;
  position: absolute;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const IonToolbar = styled(IonicIonToolbar)`
  --background: none;
  --border-width: 0 !important;
  --padding-end: 22px;
  --padding-start: 22px;
  --padding-bottom: 12px;
  --padding-top: 12px;
  --box-shadow: none;
  backdrop-filter: blur(15px);
`

export const ToolbarContent = styled.div`
  display: flex;
  justify-content: center;
`

export const ToolbarWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
`
export const CameraPreviewContent = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  ${!isMobileApp && {
    maxWidth: BODY_MAX_WIDTH,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    video: {
      width: '100%',
      maxWidth: window.screen.width,
    },
  }}
`

export const HelperText = styled.div`
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  background: ${myPalette.limeGreen.main};
  border-radius: 4px;
  margin-left: -40px;
  text-transform: uppercase;
`
